import { useTheme } from '../../contexts/ThemeContext';
import { palette } from '../../lib/palette';
import { glyph } from '../ui/icons';

type Channel = 'whatsapp' | 'instagram' | 'widget';

// Cor do canal pela paleta do Cloudscape, com contraste certo em cada tema
const META: Record<Channel, { glyph: string; label: string; light: string; dark: string }> = {
  whatsapp: { glyph: 'SMS', label: 'WhatsApp', light: palette.green.dark2, dark: palette.green.light1 },
  instagram: { glyph: 'Camera', label: 'Instagram', light: palette.purple.dark2, dark: palette.purple.light2 },
  widget: { glyph: 'Laptop', label: 'Widget', light: palette.blue.dark2, dark: palette.blue.light1 },
};

/** Pequeno badge de canal — usado na lista e no header da conversa. */
export function ChannelBadge({ channel, dense = false }: { channel: Channel; dense?: boolean }) {
  const { theme } = useTheme();
  const m = META[channel] ?? META.widget;
  const fill = theme === 'dark' ? m.dark : m.light;
  return (
    <span
      className={`inbox-channel-badge inbox-channel-badge--${channel} ${dense ? 'inbox-channel-badge--dense' : ''}`}
      title={m.label}
      style={{ color: fill }}
    >
      {dense ? (
        // Só o ícone: ele carrega o nome do canal para o leitor de tela
        glyph(m.glyph, 16)
      ) : (
        <>
          {glyph(m.glyph, 16)}
          <span className="font-semibold">{m.label}</span>
        </>
      )}
    </span>
  );
}
